module.exports = "data:application/octet-stream;base64,cHJhZ21hIHNvbGlkaXR5IF4wLjYuMDsKCmNvbnRyYWN0IER1bW15IHsKICBib29sIHB1YmxpYyBjb21wbGV0ZWQ7CiAgZnVuY3Rpb24gc2V0Q29tcGxldGVkKGJvb2wgX2NvbXBsZXRlZCkgcHVibGljIHsKICAgIGNvbXBsZXRlZCA9IF9jb21wbGV0ZWQ7CiAgfQp9Cg=="


//////////////////
// WEBPACK FOOTER
// ./contracts/levels/Dummy.sol
// module id = 1845
// module chunks = 0